export const DEEP_RESEARCH_DEFAULT_STYLE = 'academic_review';

export const DEEP_RESEARCH_STYLE_OPTIONS = [
  { value: 'academic_review', label: '学术综述' },
  { value: 'popular_science', label: '科普文章' },
  { value: 'nsfc_common', label: '课题申报' },
] as const;

export type DeepResearchStyle =
  | (typeof DEEP_RESEARCH_STYLE_OPTIONS)[number]['value']
  | 'nsfc_young_scientists_fund_type_c';

const HIDDEN_DEEP_RESEARCH_STYLE_VALUES = [
  'nsfc_young_scientists_fund_type_c',
] as const;

export function isDeepResearchStyle(
  value: string | null | undefined,
): value is DeepResearchStyle {
  return (
    DEEP_RESEARCH_STYLE_OPTIONS.some((item) => item.value === value) ||
    HIDDEN_DEEP_RESEARCH_STYLE_VALUES.some((item) => item === value)
  );
}

export function normalizeDeepResearchStyle(
  value: string | null | undefined,
): DeepResearchStyle {
  return isDeepResearchStyle(value) ? value : DEEP_RESEARCH_DEFAULT_STYLE;
}
